<mat-tab-group class="product-type-tabs" mat-align-tabs="center">
  <div *ngFor="let productTypeDetail of productTypeDetails">
      <mat-tab label="{{productTypeDetail.productTypeName}}">
        <iframe [ngClass]="{ 'product-frame': !isLandscape, 'product-frame-landscape': isLandscape}" height="1200" [src]="productTypeDetail.infoUrl! | safe"></iframe>
      </mat-tab>
    <mat-divider></mat-divider>
    </div>
</mat-tab-group>
